/* eslint-disable no-shadow */
/* eslint-disable react/no-array-index-key */
import React from 'react';
import { connect } from 'react-redux';
import { Translate, I18n } from 'react-redux-i18n';
import Switch from 'react-ios-switch';
import FIELDS from '../../data/fields';

import DropZoneComponent from '../dropzone';
import TextArea from '../elements/textArea';
import InputComponent from '../elements/input';
import SelectComponent from '../select/Select';
import {
  loadSettings, loadSettingsLong, updateSettings, updateSettingsLong, importLogo,
} from '../../app/store/actions/settings';
import DraftEditor from '../editor/draftEditor';
import SunEditor from '../editor/sunEditor';

class ParamsComponent extends React.Component {
  constructor(props) {
    super(props);
    const {
      copyright, contactUs, email, phone, whatsapp, address, about, logo, opcoHeaderMessage, opcoUrlSite, popupBody, popupEnabled, supportUrl, popupBodyButtonLabel, popupBodyURL,
    } = props.settings;

    const hasData = copyright !== undefined;

    this.state = {
      copyright,
      address,
      contactUs,
      email,
      phone,
      whatsapp,
      about,
      logo,
      message: '',
      success: '',
      setted: hasData,
      loadImage: false,
      file: '',
      opcoHeaderMessage,
      opcoUrlSite,
      supportUrl,
      popupBody,
      popupBodyButtonLabel,
      popupBodyURL,
      popupEnabled,
      selectsContactUs: [
        { id: 'email', description: 'email' },
        { id: 'phone', description: 'phone' },
        { id: 'whatsapp', description: 'whatsapp' },
      ],
    };
  }

  async componentDidMount() {
    if (this.props.isChile) {
      const settingsLong = await this.props.loadSettingsLong();
      if (settingsLong) {
        this.setState({ settingsLong, about: settingsLong.about, popupBody: settingsLong.popupBody });
      }
    }
  }

  uploadImage = async (file) => {
    const opico = this.props.settings.name;
    try {
      await this.setState({ loadImage: true });
      const extension = file[0].name.split('.').pop();
      const name = `${opico}.${extension}`;
      const logo = await importLogo(file[0], name);
      return logo.name;
    } catch (err) {
      await this.setState({ message: I18n.t('errorOcurred'), success: '' });
    } finally {
      await this.setState({ loadImage: false, success: I18n.t('saved'), message: '' });
    }
  }

  uploadedFile = async () => {
    const {
      copyright, phone, email, whatsapp, contactUs, address, about, opcoHeaderMessage,
      opcoUrlSite, supportUrl, popupBody, popupBodyButtonLabel, popupBodyURL, popupEnabled, file,
    } = this.state;
    const { companyTag, updateSettings, updateSettingsLong, isChile } = this.props;

    let popupBodyCheck = popupBody.trim();

    if (popupBodyCheck.substring(0, 5) !== '<div>' || popupBodyCheck.substring(popupBodyCheck.length - 6) !== '<div>') {
      popupBodyCheck = `<div>${popupBodyCheck}</div>`;
    }

    try {
      if (isChile) {
        await updateSettings({
          copyright,
          phone,
          email,
          whatsapp,
          contactUs,
          address,
          opcoHeaderMessage,
          opcoUrlSite,
          supportUrl,
          popupBodyButtonLabel,
          popupBodyURL,
          popupEnabled,
          companyTag,
        });
        await updateSettingsLong({
          about, popupBody: popupBodyCheck,
        });
      } else {
        await updateSettings({
          copyright,
          phone,
          email,
          whatsapp,
          contactUs,
          address,
          about,
          opcoHeaderMessage,
          opcoUrlSite,
          supportUrl,
          popupBody: popupBodyCheck,
          popupBodyButtonLabel,
          popupBodyURL,
          popupEnabled,
          companyTag,
        });
      }

      if (file) {
        await this.uploadImage(file);
      }

      await this.setState({ message: '', success: I18n.t('saved') });
    } catch (err) {
      await this.setState({ message: I18n.t('errorOcurred'), success: '' });
    }
  }

  setHtml = async (about) => {
    await this.setState({ about, message: '', success: '' });
  }

  setHtmlPopupBody = async (popupBody) => {
    await this.setState({ popupBody, message: '', success: '' });
  }

  selectedItem = (attr, value) => {
    this.setState({ contactUs: value.target.value, message: '', success: '' });
  }

  render() {
    const {
      copyright,
      phone,
      address,
      message,
      success,
      about,
      setted,
      loadImage,
      logo,
      file,
      opcoHeaderMessage,
      opcoUrlSite,
      supportUrl,
      popupBodyButtonLabel,
      popupBodyURL,
      popupBody = '',
      popupEnabled,
      selectsContactUs,
      contactUs,
      email,
      whatsapp,
    } = this.state;

    const { isChile, companyTag } = this.props;

    if (isChile && !this.state.settingsLong) {
      return (<React.Fragment />);
    }

    return (
      <React.Fragment>
        <div className="row justify-content-center">
          <img
            src={logo || 'images/default-logo.png'}
            className="img-logo-params"
            alt="Logo"
          />
        </div>
        <div className="row justify-content-center">
          <div className="dropzone-out">
            <DropZoneComponent
              uploadedFile={e => this.setState({ file: e })}
              title={I18n.t('dragAndDrop')}
              loadImage={loadImage}
              fileName={file && file[0].name}
            />
          </div>

        </div>
        <div className="layout-params-div">
          <p className="margin-bottom-2"><Translate value="aboutUs" /></p>
          {setted && isChile && <SunEditor content={about} setHtml={this.setHtml} />}
          {setted && !isChile && <DraftEditor value={about} setHtml={this.setHtml} />}
          <TextArea
            title="Copyright"
            onChange={e => this.setState({ copyright: e.target.value, message: '', success: '' })}
            value={copyright}
            maxLength={FIELDS.copyright}
            placeHolder=""
            rows={3}
          />
          <InputComponent
            type="text"
            title={I18n.t('address')}
            className="form-control"
            placeHolder=""
            onChange={e => this.setState({ address: e.target.value, message: '', success: '' })}
            value={address}
            maxLength={FIELDS.max}
          />

          {
            companyTag === 'nortel' ? (
              <React.Fragment>
                <SelectComponent
                  title={I18n.t('contactUs')}
                  value={contactUs}
                  body={selectsContactUs.map((val, index) => (
                    <option
                      key={`${val.id}_${index}_${val.description}`}
                      value={val.id}
                    >
                      {I18n.t(`${val.description}`)}
                    </option>
                  ))}
                  onChange={e => this.selectedItem(contactUs, e)}
                  tooltip=""
                />
                { contactUs === 'phone' && (
                  <InputComponent
                    type="text"
                    title={I18n.t('phone')}
                    className="form-control"
                    placeHolder=""
                    onChange={e => this.setState({ phone: e.target.value, message: '', success: '' })}
                    value={phone}
                    maxLength={FIELDS.default}
                  />
                )}
                { contactUs === 'whatsapp' && (
                  <InputComponent
                    type="text"
                    title={I18n.t('whatsapp')}
                    className="form-control"
                    placeHolder=""
                    onChange={e => this.setState({ whatsapp: e.target.value, message: '', success: '' })}
                    value={whatsapp}
                    maxLength={FIELDS.default}
                  />
                )}
                { contactUs === 'email' && (
                  <InputComponent
                    type="email"
                    title={I18n.t('email')}
                    className="form-control"
                    placeHolder=""
                    onChange={e => this.setState({ email: e.target.value, message: '', success: '' })}
                    value={email}
                    maxLength={FIELDS.default}
                  />
                )}
              </React.Fragment>
            ) : (
              <InputComponent
                type="text"
                title={I18n.t('phone')}
                className="form-control"
                placeHolder=""
                onChange={e => this.setState({ phone: e.target.value, message: '', success: '' })}
                value={phone}
                maxLength={FIELDS.default}
              />
            )
          }
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <p className="margin-bottom-2"><Translate value="popupBody" /></p>
            <Switch
              checked={!!popupEnabled && popupEnabled.trim() === 'true'}
              className="margin-bottom-2"
              style={{ marginLeft: 10 }}
              onChange={value => this.setState({ popupEnabled: value ? 'true' : 'false' })}
            />
          </div>
          {isChile
            ? <SunEditor content={popupBody} setHtml={this.setHtmlPopupBody} />
            : <DraftEditor value={popupBody} setHtml={this.setHtmlPopupBody} />
          }

          { isChile && (
            <InputComponent
              type="text"
              title={I18n.t('popupBodyButtonLabel')}
              className="form-control"
              placeHolder=""
              onChange={e => this.setState({ popupBodyButtonLabel: e.target.value, message: '', success: '' })}
              value={popupBodyButtonLabel}
              maxLength={FIELDS.default}
            />
          )}
          { isChile && (
            <InputComponent
              type="text"
              title={I18n.t('popupBodyURL')}
              className="form-control"
              placeHolder=""
              onChange={e => this.setState({ popupBodyURL: e.target.value, message: '', success: '' })}
              value={popupBodyURL}
              maxLength={FIELDS.popupBodyURL.maxLength}
            />
          )}
          <InputComponent
            type="text"
            title={I18n.t('opcoHeaderMessage')}
            className="form-control"
            placeHolder=""
            onChange={e => this.setState({ opcoHeaderMessage: e.target.value, message: '', success: '' })}
            value={opcoHeaderMessage}
            maxLength={FIELDS.opcoHeaderMessage.maxLength}
          />
          <InputComponent
            type="text"
            title={I18n.t('opcoUrlSite')}
            className="form-control"
            placeHolder=""
            onChange={e => this.setState({ opcoUrlSite: e.target.value, message: '', success: '' })}
            value={opcoUrlSite}
            maxLength={FIELDS.opcoUrlSite.maxLength}
          />
          { isChile && (
          <InputComponent
            type="text"
            title={I18n.t('supportUrlSite')}
            className="form-control"
            placeHolder=""
            onChange={e => this.setState({ supportUrl: e.target.value, message: '', success: '' })}
            value={supportUrl}
            maxLength={FIELDS.supportUrl.maxLength}
          />
          )}
        </div>
        <button
          onClick={() => this.uploadedFile()}
          type="button"
          className="btn btn-secondary margin-bottom-20"
        >
          <Translate value="save" />
        </button>

        {success && <p className="color-green margin-top-10">{success}</p>}
        {message && <p className="color-red margin-top-10">{message}</p>}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  settings: state.settings,
  companyTag: state.settings && state.settings.companyTag,
  isChile: state.settings && state.settings.companyTag == 'chile',
});

const mapDispatchToProps = dispatch => ({
  loadSettings: () => dispatch(loadSettings()),
  loadSettingsLong: () => dispatch(loadSettingsLong()),
  updateSettings: settings => dispatch(updateSettings(settings)),
  updateSettingsLong: settingsLong => dispatch(updateSettingsLong(settingsLong)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ParamsComponent);
